import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter  } from "react-router-dom";
import App from "./App";
import { NotificationsProvider } from "./notifications/NotificationsContext";

import "./styles/home.css";
import "./styles/auth.css";
import "./styles/move-theme.css";

function normalizeHashRouterUrl() {
    const base = import.meta.env.BASE_URL || "/";
    const normalizedBase = base.endsWith("/") ? base : `${base}/`;
    const { pathname, search, hash } = window.location;
    const isBasePath = pathname === normalizedBase || pathname === normalizedBase.slice(0, -1);
    const isRootPath = pathname === "/";

    if (isBasePath || isRootPath) return;

    if (pathname.startsWith(normalizedBase)) {
        const pathRoute = pathname.slice(normalizedBase.length);
        const hashRoute = hash.startsWith("#/") ? hash : pathRoute ? `#/${pathRoute}` : "#/";
        window.history.replaceState(null, "", `${normalizedBase}${search}${hashRoute}`);
        return;
    }

    if (hash.startsWith("#/")) {
        window.history.replaceState(null, "", `${normalizedBase}${search}${hash}`);
    }
}

normalizeHashRouterUrl();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <HashRouter>
            <NotificationsProvider>
                <App />
            </NotificationsProvider>
        </HashRouter>
    </React.StrictMode>
);
